import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const retakePhoto = async ({ photoId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/retake_photo/${photoId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useRetakePhotoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: retakePhoto,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["photo_session_view"] });
    },
    onError: (error) => {
      console.error("Failed to retake photo:", error);
    },
  });
};

export default useRetakePhotoMutation;
